import _ from "lodash";
import React, { createRef, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import {
  getAnyTotalReportClear,
  getProfileCompletionReport,
  getProfileCompletionReportClear,
} from "../../../redux/reports/actions";
import NextArrow from "../../LearningPaths/NextArrow";
import PrevArrow from "../../LearningPaths/PrevArrow";
import Pagination from "../../../pages/Orders/Pagination";
import exportFromJSON from "export-from-json";
import StaticUtils from "../../../utils/StaticUtils";
import * as XLSX from "xlsx";
import PieChart from "../../Layouts/Graphs/PieChart";
import ReportGraphSection from "../ReportGraphSection";
import { SessionKeys } from "../../../utils/AppUtils";
import PaginationProgress from "./PaginationProgress";
import moment from "moment";
import NotFoundImage from "../../NewDesign/NotFound/NotFoundImage";
const fileName = "CourseProgress";
const exportType = "xls";
let PageSize = 20;
const sliderRef = createRef();
const settings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  dots: true,
  arrows: true,
  autoplaySpeed: 2000,
  infinite: false,
  centerMode: false,
  swipe: false,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
const ProgressReportTableComponentForAgentDetail = (props) => {

  const {
    getFilteredData,
    setIsLoading,
    isLoading,
    isView,
    statusFilterData,
    setCanShow,
    type,
    profileReports,
    message,
    isCompliance,
    searchTable,
    // currentTableData,
    //currentPage,
    fromPage
  } = props;

  const dispatch = useDispatch();
  const profileReportRes = useSelector((state) => state.report.profileReport);
  const anyTotalReportRes = useSelector((state) => state.report.anyTotalReport);
  const authBroker = useSelector((state) => state.auth.authBroker)
  const authIframeBroker = useSelector(state => state.auth.authIframeBroker)
  // const [profileReports, setProfileReports] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [legends, setLegends] = useState([]);
  const [series, setSeries] = useState([]);
  const [searchInput, setSearchInput] = useState('')
  const [statusSort, setStatusSort] = useState('asc')
  const [progressSort, setProgressSort] = useState('asc')
  const [officeLabel, setOfficeLabel] = useState('')

  useEffect(() => {
		if (!_.isEmpty(authBroker)) {
			if (!_.isEmpty(authBroker.payload?.user?.config) && authBroker.payload?.user?.config.office_name) {
				setOfficeLabel(authBroker.payload?.user?.config.office_name)
			} else {
				setOfficeLabel('Office Name')
			}
		}
	}, [authBroker])

  useEffect(() => {
		if (!_.isEmpty(authIframeBroker)) {
      // alert(JSON.stringify(authIframeBroker.payload.user.config))
			if (!_.isEmpty(authIframeBroker.payload?.user?.config) && authIframeBroker.payload?.user?.config.office_name) {
				setOfficeLabel(authIframeBroker.payload?.user?.config.office_name)
			} else {
				setOfficeLabel('Office Name')
			}
		}
	}, [authIframeBroker])

  const currentTableData = useMemo(() => {
    if (profileReports !== null) {
      let reportsData = _.clone(profileReports);
      reportsData = _.sortBy(reportsData, 'profile_status');
      if (statusSort === 'desc') {
        reportsData = _.reverse(reportsData)
      }
      reportsData = _.sortBy(reportsData, 'profile_progress');
      if (progressSort === 'desc') {
        reportsData = _.reverse(reportsData)
      }
      const firstPageIndex = (currentPage - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      setCanShow(true);
      let tableData = reportsData?.slice(firstPageIndex, lastPageIndex)
      console.log('tableData: ', tableData);
      return tableData;
    }
  }, [currentPage, profileReports, statusSort, progressSort]);

  const ExportToExcel = () => {
    const data = _.cloneDeep(profileReports);
    for (let item of data) {
      item.profile_status =
        item?.profile_status === "Inprogress"|| item?.profile_status === "in-progress"
          ? "In Progress"
          : item?.profile_status === "Yet to start" || item?.profile_status === "not-started"
            ? "Yet to start"
            : (item?.profile_status === "OverDue" || item?.profile_status.toLowerCase() === 'overdue')
              ? "Overdue"
              : "Completed";
      item.profile_progress =
        item?.profile_progress !== undefined && item?.profile_progress !== ""
          ? item?.profile_progress + "%"
          : "-";
      item.complete_date =
        item?.complete_date !== undefined && item?.complete_date !== ""
          ? moment(
            StaticUtils.getDateFromTimeStamp(item?.complete_date),
            "MM/DD/YYYY"
          ).format("DD MMM, YYYY")
          : "-";
    }

    //for sequencing
    let tempArr = [];
    for (const item of data) {
      let obj = {
        "first_name": item.first_name,
        "last_name": item.last_name,
        "email": item.email,
        "office_name": item.office_name,
        "course_name": item.course_name,
        "profile_status": item.profile_status,
        "profile_progress": item.profile_progress,
        "complete_date": item.complete_date,
      }
      tempArr.push(obj)

    }


    const newThing = [];
    tempArr.map((item) => {
      newThing.push(
        _.mapKeys(item, (value, key) => {
          switch (key) {
            case "first_name":
              return "First Name";
            case "last_name":
              return "Last Name";
            case "email":
              return "Email";
            case "office_name":
              return officeLabel;
            case "course_name":
              return "Course Name";
            case "profile_status":
              return "Status";
            case "profile_progress":
              return "% Completed";
            case "complete_date":
              return "Date of Completion";
            default:
              return;
          }
        })
      );
    });

    for (let i = 0; i < newThing.length; i++) {
      // arrayObj[i].stroke = arrayObj[i]['key1'];
      delete newThing[i].undefined;
    }

    for (let i = 0; i < data.length; i++) {
      // arrayObj[i].stroke = arrayObj[i]['key1'];
      delete data[i]._id;
    }
    // console.log('data:', data)
    // exportFromJSON({ data, fileName, exportType })

    //For mobile
    let tempObj = {
      method: isCompliance ? "ComplianceReport" : "LearningProgressReport",
      report: newThing
    }
    if (window.callbackHandler != undefined) {
      window.callbackHandler.postMessage(JSON.stringify(tempObj));
    } else if (window.webkit != undefined) {
      if (window.webkit.messageHandlers.callbackHandler != undefined) {
        window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(tempObj));
      }
    }



    const worksheet = XLSX.utils.json_to_sheet(newThing);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    let fileNameNew = isCompliance ? "ComplianceReport" : "LearningProgressReport"
    XLSX.writeFile(workbook, fileNameNew + ".xlsx");
  };

  const renderTableReport = () => {
    return (
      <div className="row list-coach report-table-rsp">
        <div className="col-lg-12 col-md-12">
          <div className="table-responsive1">
            <div className="tablebox">
              <table className="table mb-0 office_list table-striped">
                <thead>
                  <tr>
                    <th className="office-province">Name</th>
                    <th className="office-province">Started</th>
                    <th className={`office-province cursor-pointer`}
                    // ${statusSort === 'asc' ? '' : 'decend'}`}
                    //   onClick={() => { setStatusSort(statusSort === 'asc' ? 'desc' : 'asc') }}
                    >Status</th>
                    <th className={`office-province sortingtable cursor-pointer 
                    ${progressSort === 'asc' ? '' : 'decend'}`}
                      onClick={() => { setProgressSort(progressSort === 'asc' ? 'desc' : 'asc') }}
                    >Progress %</th>
                    <th className="office-province">Completed</th>
                  </tr>
                </thead>
                <tbody>
                  {currentTableData?.map((item, index) => {
                    return (
                      <tr className="addBGcustomw">
                        <td>{fromPage === 1 ? item?.course_name : item?.lp_name}</td>
                        <td>{item?.start_date === "" ? "--" : moment(
                          StaticUtils.getDateFromTimeStamp(
                            item?.start_date
                          ),
                          "MM/DD/YYYY"
                        ).format("DD MMM, YYYY")}</td>
                        <td className={item?.profile_status === "Inprogress"|| item?.profile_status === "in-progress"
                          ? "inprogress-sta status-rp"
                          : item?.profile_status === "Yet to start" || item?.profile_status === "not-started"
                            ? "start-sta-nonod status-rp"
                            : (item?.profile_status === "OverDue" || item?.profile_status.toLowerCase() === 'overdue')
                              ? "overdue-sta status-rp"
                              : "completed-sta status-rp"}>

                          <strong>
                            {item?.profile_status === "Inprogress"|| item?.profile_status === "in-progress"
                              ? "In Progress"
                              : item?.profile_status === "Yet to start" || item?.profile_status === "not-started"
                                ? "Yet to start"
                                : (item?.profile_status === "OverDue" || item?.profile_status.toLowerCase() === 'overdue')
                                  ? "Overdue"
                                  : "Completed"}
                          </strong>
                        </td>
                        <td className="text-center">
                          <strong>
                            {item?.profile_progress !== undefined &&
                              item?.profile_progress !== ""
                              ? item?.profile_progress + "%"
                              : "-"}
                          </strong>
                        </td>
                        <td>{item?.complete_date ? moment(
                          StaticUtils.getDateFromTimeStamp(
                            item?.complete_date
                          ),
                          "MM/DD/YYYY"
                        ).format("DD MMM, YYYY") : "--"}</td>

                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <PaginationProgress
              className="pagination-bar "
              currentPage={currentPage}
              totalCount={profileReports?.length}
              pageSize={PageSize}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderGraphReport = () => {
    return (
      <ReportGraphSection
        series={series}
        legends={legends}
        isLoading={isLoading}
        type={type}
        isAmount={false}
      />
    );
  };

  return (
    <>

      <section className="table-report-layout mt-4 pt-2">
        <div className="container col-md-12 search__input mb-4">
          <div className="input-lear position-relative d-flex">
            <label for="search" className="input__label_learning">Search</label>
            <input type="text" id="search" name="search" className="input_searchfield_search mb-0"
              autocomplete="off" onChange={(evt) => {
                if (!evt.target.value) searchTable('')
                setSearchInput(evt.target.value) 
              }}
            />
            <button className="button-reset" onClick={() => { searchTable(searchInput) }} >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                id="Find"
                width="28"
                height="28"
                viewBox="0 0 30 30"
              >
                <defs>
                  <linearGradient
                    id="linear-gradient"
                    y1="0.5"
                    x2="1"
                    y2="0.5"
                    gradientUnits="objectBoundingBox"
                  >
                    <stop offset="0" stop-color="#6941C6" />
                    <stop offset="1" stop-color="#ed156e" />
                  </linearGradient>
                </defs>
                <circle
                  id="Ellipse_191"
                  data-name="Ellipse 191"
                  cx="15"
                  cy="15"
                  r="15"
                  fill="url(#linear-gradient)"
                />
                <circle
                  id="Ellipse_192"
                  data-name="Ellipse 192"
                  cx="13"
                  cy="13"
                  r="13"
                  transform="translate(2 2)"
                  fill="#fff"
                />
                <path
                  id="Icon_awesome-search"
                  data-name="Icon awesome-search"
                  d="M14.372,12.6,11.535,9.762a.683.683,0,0,0-.484-.2h-.464a5.917,5.917,0,1,0-1.025,1.025v.464a.683.683,0,0,0,.2.484L12.6,14.372a.68.68,0,0,0,.965,0l.805-.805A.686.686,0,0,0,14.372,12.6ZM5.92,9.562A3.643,3.643,0,1,1,9.562,5.92,3.641,3.641,0,0,1,5.92,9.562Z"
                  transform="translate(7.715 7.714)"
                  fill="#6941C6"
                />
              </svg>
            </button>
          </div>
        </div>
        {true ? (
          <div className="container">
            {currentTableData && currentTableData?.length > 0 ? (
              renderTableReport()
            ) : profileReports !== null ? (
              <div className="not-found mt-3">
                <div className=" interboxes">
                  {/* <img src="/images/telescope.svg" alt="Not Found" /> */}
                  <NotFoundImage />
                  <p>{message}</p>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </section >
    </>
  );
};

export default ProgressReportTableComponentForAgentDetail;
